import React from 'react';
import { Box, BoxProps } from 'rebass';
import { ucFirst } from '@ecosconnect/core/src/helpers/string';

export type NewStatusStyle =
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'blue'
  | 'purple';

export type StatusStyle =
  | 'default'
  | 'pending'
  | 'success'
  | 'error'
  | 'primary'
  | 'warning';

export type CombinedStatusStyle = NewStatusStyle | StatusStyle;

type StatusDotProps = BoxProps & {
  status?: CombinedStatusStyle;
  color?: string;
};

const StatusDot = ({
  status = 'default',
  color,
  ...props
}: StatusDotProps): JSX.Element => {
  const bgString = color ? color : `status${ucFirst(status)}`;
  return (
    <Box
      {...(props as any)}
      variant="dotDefault"
      bg={bgString.indexOf('gradient') === -1 ? bgString : undefined}
      sx={{
        display: 'inline-block',
        background: bgString.indexOf('gradient') !== -1 ? bgString : undefined,
      }}
    />
  );
};

export default StatusDot;
